import React from 'react'

import style from './Categories.module.css'
import { CategoriesList } from './CategoriesList/CategoriesList'
import { CategoriesSearch } from './CategoriesSearch/CategoriesSearch'

import { useAppSelector } from 'common/hooks'
import { selectCategoriesBySearch } from 'features/dashboard'
import { SectionHeader } from 'layout'

export const Categories = () => {
  const searchedCategories = useAppSelector(selectCategoriesBySearch)

  return (
    <section className={style.section}>
      <SectionHeader title="Категории" />
      <div className={`${style.box} box`}>
        <CategoriesSearch />
        {searchedCategories.length === 0 && <p className={style.message}>Ничего не найдено...</p>}
        <CategoriesList />
      </div>
    </section>
  )
}
